// **********************************************************
// Teaser lider
// **********************************************************
/* eslint-disable */
$(function () {
  new Swiper('.teaser-slider', {
    slidesPerView: 'auto',
    spaceBetween: 18,
    freeMode: true,
    breakpoints: {
      600: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
    },
  });
});
/* eslint-enable */
